<template>
  <div :class="tableClassName">
    <div class="list-group-header">
      <div v-if="isOrdered" class="promotion-priority-col-0">
        <span></span>
      </div>
      <div v-if="isOrdered" class="promotion-priority-col-1">
        <span>Order</span>
      </div>
      <div class="promotion-priority-col-2">
        <span>Prompt</span>
      </div>
    </div>
    <draggable
      v-model="orderedPaths"
      tag="div"
      itemKey="id"
      v-bind="dragOptions"
      class="priority-list-wrapper"
      @start="isDragging = true"
      @end="isDragging = false"
    >
      <template #item="{ element: item, index }">
        <span class="list-group-item">
          <span v-if="isOrdered" class="promotion-priority-col-0">
            <v-icon size="small">md:drag_indicator</v-icon>
          </span>
          <span v-if="isOrdered" class="promotion-priority-col-1">
            <span>{{ index + 1 }}</span>
          </span>
          <span class="promotion-priority-col-2">
            <span>{{ item.name }}</span>
            <span class="seq-action-btns-div">
              <v-icon
                size="18"
                style="margin-left: 10px"
                class="delete-path-sequence-button"
                @click="deletePathSequence(index)"
                >md:clear</v-icon
              >
            </span>
          </span>
        </span>
      </template>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { canReorder } from "@/utils/guideHelpers";

export default {
  name: "RfSequencePathsDisplayTable",
  components: { draggable },
  props: ["paths", "sequence"],
  data() {
    return {
      orderedPaths: this.paths,
    };
  },
  computed: {
    tableClassName() {
      if (this.isOrdered) {
        return "seq-table-ordered-ls";
      }
      return "seq-table-ordered-ls unordered-tbl";
    },
    isOrdered() {
      return canReorder(this.sequence);
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.isOrdered,
        ghostClass: "ghost",
      };
    },
  },
  watch: {
    orderedPaths(to) {
      this.$emit("updateOrder", to);
    },
  },
  methods: {
    deletePathSequence(index) {
      this.$emit("delete", index);
    },
    editPathSequence(index) {
      this.$emit("edit", index);
    },
  },
};
</script>
